module.exports = __webpack_public_path__ + "img/technische-universitat.f2c10efb.jpg";